/*
  <quantity-input>: a number input with decrease and increase buttons.
  Markup comes from snippets/quantity-input.liquid. The element keeps the value
  on the grid defined by the input's min, max and step attributes and fires a
  bubbling "change" event on the input whenever a button changes the value.
*/
if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      if (!this.input || this.ready) return;
      this.ready = true;
      this.addEventListener('click', (event) => this.onClick(event));
      this.input.addEventListener('change', () => this.onInputChange());
      this.refresh();
    }

    get limits() {
      const min = this.input.min === '' ? 0 : Number(this.input.min);
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      const step = Number(this.input.step) > 0 ? Number(this.input.step) : 1;
      return { min, max, step };
    }

    /* Snaps a number to the nearest allowed quantity. */
    normalize(number) {
      const { min, max, step } = this.limits;
      if (!Number.isFinite(number)) return min;
      let value = min + Math.round((number - min) / step) * step;
      if (value < min) value = min;
      while (value > max) value -= step;
      return Math.max(value, min);
    }

    onClick(event) {
      const button = event.target.closest('[data-quantity-step]');
      if (!button || !this.contains(button) || this.input.disabled) return;
      const direction = Number(button.dataset.quantityStep);
      const current = this.normalize(Number(this.input.value));
      const next = this.normalize(current + direction * this.limits.step);
      if (String(next) !== this.input.value) {
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.refresh();
    }

    onInputChange() {
      const next = this.normalize(Number(this.input.value));
      if (String(next) !== this.input.value) this.input.value = next;
      this.refresh();
    }

    /* Disables a button once the value reaches that end of the range. */
    refresh() {
      const { min, max } = this.limits;
      const value = Number(this.input.value);
      this.querySelectorAll('[data-quantity-step]').forEach((button) => {
        const atLimit = Number(button.dataset.quantityStep) < 0 ? value <= min : value >= max;
        if (atLimit && document.activeElement === button) this.input.focus();
        button.disabled = atLimit || this.input.disabled;
      });
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
